/* eslint-disable @typescript-eslint/no-explicit-any -- pre-existing legacy typing, matches the rest of the codebase */
import barrelsSvg from "assets/images/barrels.svg";
import bigbagsSvg from "assets/images/bigbags.svg";
import boxSvg from "assets/images/box.svg";
import bulkSvg from "assets/images/bulk.svg";
import palletSvg from "assets/images/pallet.svg";
import pipesSvg from "assets/images/pipes.svg";
import rollsSvg from "assets/images/rolls.svg";
import sacksSvg from "assets/images/sacks.svg";

export const types_img: any = {
  barrels: barrelsSvg,
  bigbags: bigbagsSvg,
  box: boxSvg,
  bulk: bulkSvg,
  pipes: pipesSvg,
  roll: rollsSvg,
  sacks: sacksSvg,
  pallet: palletSvg,
};

const genericImageModules = import.meta.glob<string>("../assets/images/*.{svg,png}", {
  eager: true,
  import: "default",
});

const genericImagesByName: Record<string, string> = Object.fromEntries(
  Object.entries(genericImageModules).map(([path, url]) => [path.replace(/^.*\//, "").replace(/\.(svg|png)$/, ""), url])
);

export const getImageSrc = (name: string): string => genericImagesByName[name] ?? "";
